var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIconTestResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 25.5C20.8333 23 23.7 18 24.5 18H26L42.5 25.5L44 30L41.5 34.5L28.5 44.5L21 39L19.5 25.5Z",
    fill: "#010103"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 55C43.807 55 55 43.807 55 30C55 16.1929 43.807 5 30 5C16.1929 5 5 16.1929 5 30C5 43.807 16.1929 55 30 55ZM26.7337 39.6145L38.5342 32.6475C40.4885 31.4935 40.4885 28.5065 38.5342 27.3525L26.7337 20.3855C24.8343 19.264 22.5 20.7237 22.5 23.0329V36.967C22.5 39.2763 24.8343 40.736 26.7337 39.6145Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconTestResult);
export default __webpack_public_path__ + "static/media/play-icon-test-result.71be3f28efc50aa11ca55fbdff5d958f.svg";
export { ForwardRef as ReactComponent };